/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-case-declarations */
import React, {
  createContext,
  ReactNode,
  useReducer,
  useMemo,
  useEffect,
  useContext,
} from 'react';
import defaults from '../../translations/en.json';
import { Context } from '../../context';
import {
  SET_IDG_CONFIG,
  SET_API_STATUS,
  SET_EXPANDED_ROW,
  CLOSE_ROW,
  ADD_DISPLAYED_ROW,
  Info,
} from './constants';
import { generateIDGConfig, generatePrintNames } from './IDGUtils';

/* Context for managing messaging to and from PIM */

type IDGContextProviderProps = {
  children: ReactNode;
};

// todo: refactor to new app translations
const defaultStatusMessage: mumms.ErrorInfo = {
  text: defaults.documentRendering,
  severity: Info,
};

type IDGContext = {
  idgConfig: any;
  idgWidgetNames: any;
  apiError: mumms.ErrorInfo | null;
  widgetsReady: string[];
  openRows: string[];
  displayedRows: string[];
  dispatch?: any;
};

type IDGContextState = {
  idgConfig: any;
  idgWidgetNames: any;
  apiError: mumms.ErrorInfo | null;
  widgetsReady: string[];
  openRows: string[];
  displayedRows: string[];
  dispatch?: any;
};

const initialState = {
  idgConfig: null,
  idgWidgetNames: null,
  apiError: null,
  widgetsReady: [],
  openRows: [],
  displayedRows: [],
};

const initIDGContext = {
  idgConfig: null,
  idgWidgetNames: null,
  apiError: null,
  widgetsReady: [],
  openRows: [],
  displayedRows: [],
};

export const IDGContextReducer = (
  state: IDGContextState,
  action: { type: string; payload: any },
) => {
  let newState = { ...state };
  const { payload } = action;

  switch (action.type) {
    case SET_IDG_CONFIG:
      newState.idgConfig = payload.idgConfig;
      newState.idgWidgetNames = payload.idgWidgetNames;
      break;
    case SET_API_STATUS:
      newState.apiError = payload;
      break;
    case SET_EXPANDED_ROW:
      newState.openRows = [action.payload];
      break;
    case CLOSE_ROW:
      newState.openRows = state.openRows.filter(
        (widget: string) => widget !== action.payload,
      );
      break;
    case ADD_DISPLAYED_ROW:
      newState.displayedRows = state.openRows.concat(action.payload);
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const IDGContext = createContext<IDGContext>(
  initIDGContext as IDGContext,
);

export const IDGDispatchContext = createContext({});
export const IDGContextConsumer = IDGContext.Consumer;
export const IDGDispatchContextConsumer = IDGDispatchContext.Consumer;

export const IDGContextProvider = ({ children }: IDGContextProviderProps) => {
  const [
    {
      idgConfig,
      idgWidgetNames,
      apiError,
      widgetsReady,
      openRows,
      displayedRows,
    },
    dispatch,
  ] = useReducer(IDGContextReducer, initialState);

  const { printConfig, printConfigNames } = useContext(Context);

  const context = useMemo(
    () => ({
      idgConfig,
      idgWidgetNames,
      apiError,
      widgetsReady,
      openRows,
      displayedRows,
      dispatch,
    }),
    [
      idgConfig,
      idgWidgetNames,
      apiError,
      widgetsReady,
      openRows,
      displayedRows,
      dispatch,
    ],
  );

  return <IDGContext.Provider value={context}>{children}</IDGContext.Provider>;
};

export function withIDGContext(Component: any) {
  return function contextComponent(props: any) {
    return (
      <IDGContextConsumer>
        {(context) => (
          <IDGDispatchContextConsumer>
            {(dispatchContext) => (
              <Component {...props} {...context} {...dispatchContext} />
            )}
          </IDGDispatchContextConsumer>
        )}
      </IDGContextConsumer>
    );
  };
}

export default IDGContext;
